var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shopping_note",staticStyle:{"background-image":"url('/img/callback.jpg')"}},[_c('b-container',{staticClass:"py-5"},[_c('div',{staticClass:"shopping_note-card",domProps:{"innerHTML":_vm._s(_vm.note)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }